import { message, Select, Spin, Tag } from "antd";
import { PlusOutlined, LinkOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import axios from "axios";
import debounce from "lodash.debounce";
import moment from "moment";
import { connect } from "react-redux";
import { ModalItem } from "../../../../Components/Items";

const { Option } = Select;

class OpcionCard extends Component {
  state = { hover: false };
  render() {
    const { icono, titulo, descripcion, onClick } = this.props;
    const { hover } = this.state;
    return (
      <div
        onClick={onClick}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        style={{
          flex: 1,
          cursor: "pointer",
          borderRadius: 12,
          padding: "24px 18px",
          textAlign: "center",
          border: hover ? "1.5px solid #00BFD6" : "1.5px solid #eee",
          background: hover ? "#f0fcfd" : "#fafafa",
          boxShadow: hover ? "0 4px 14px rgba(0,191,214,0.15)" : "0 1px 3px rgba(0,0,0,0.04)",
          transition: "all 0.15s ease",
        }}
      >
        <div style={{ fontSize: 28, color: hover ? "#00BFD6" : "#888", marginBottom: 10 }}>{icono}</div>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#333", marginBottom: 6 }}>{titulo}</div>
        <div style={{ fontSize: 12.5, color: "#888" }}>{descripcion}</div>
      </div>
    );
  }
}

class ElegirPreCotizacion extends Component {
  state = {
    paso: "eleccion",
    opciones: [],
    cargando: false,
    preCotizacionIdSeleccionada: null,
    preCotizacionSeleccionada: null,
    confirmLoading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({
        paso: "eleccion",
        opciones: [],
        preCotizacionIdSeleccionada: null,
        preCotizacionSeleccionada: null,
      });
    }
  }

  buscarPreCotizaciones = debounce((texto) => {
    this.setState({ cargando: true });
    axios
      .post(
        "preCotizacionIngenieria/selectPreCotizacionesItem",
        { empresaId: this.props.empresaId, texto, soloSinLigar: true },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ opciones: res.data.success === 2 ? res.data.data || [] : [] });
      })
      .catch(() => this.setState({ opciones: [] }))
      .finally(() => this.setState({ cargando: false }));
  }, 300);

  irACrearNueva() {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria", { cotizacionId: this.props.cotizacionId });
    this.props.onCerrar(false);
  }

  irALigarExistente() {
    this.setState({ paso: "ligarExistente" }, () => this.buscarPreCotizaciones(""));
  }

  seleccionar(value) {
    const preCotizacion = this.state.opciones.find((op) => op._id === value) || null;
    this.setState({ preCotizacionIdSeleccionada: value, preCotizacionSeleccionada: preCotizacion });
  }

  ligar() {
    if (!this.state.preCotizacionIdSeleccionada) {
      return message.warning("Selecciona una pre cotización");
    }
    this.setState({ confirmLoading: true });
    axios
      .post(
        "preCotizacionIngenieria/ligarCotizacion",
        {
          empresaId: this.props.empresaId,
          preCotizacionId: this.state.preCotizacionIdSeleccionada,
          cotizacionId: this.props.cotizacionId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ confirmLoading: false });
        if (res.data.success === 2) {
          message.success("Pre cotización ligada");
          this.props.onCerrar(true);
        } else {
          message.error("No se pudo ligar la pre cotización");
        }
      });
  }

  render() {
    const { paso, preCotizacionSeleccionada } = this.state;

    return (
      <ModalItem
        title={
          paso === "ligarExistente" ? (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <ArrowLeftOutlined
                style={{ cursor: "pointer", fontSize: 16 }}
                onClick={() => this.setState({ paso: "eleccion" })}
              />
              <span>Ligar Pre Cotización Existente</span>
            </div>
          ) : (
            "Pre Cotización"
          )
        }
        visible={this.props.visible}
        onCancel={() => this.props.onCerrar(false)}
        footer={paso === "ligarExistente"}
        onOk={this.ligar.bind(this)}
        okText="Ligar"
        cancelText="Cancelar"
        confirmLoading={this.state.confirmLoading}
      >
        {paso === "eleccion" && (
          <div style={{ display: "flex", gap: 16, padding: "8px 0 16px" }}>
            <OpcionCard
              icono={<PlusOutlined />}
              titulo="Crear Nueva"
              descripcion="Empieza una pre cotización en blanco, ligada a esta cotización."
              onClick={this.irACrearNueva.bind(this)}
            />
            <OpcionCard
              icono={<LinkOutlined />}
              titulo="Ligar Existente"
              descripcion="Busca una pre cotización ya creada y ligala a esta cotización."
              onClick={this.irALigarExistente.bind(this)}
            />
          </div>
        )}

        {paso === "ligarExistente" && (
          <>
            <Select
              showSearch
              allowClear
              filterOption={false}
              placeholder="Busca por folio o nombre de proyecto"
              style={{ width: "100%" }}
              loading={this.state.cargando}
              notFoundContent={
                this.state.cargando ? (
                  <div style={{ textAlign: "center", padding: "8px" }}>Buscando...</div>
                ) : (
                  "No se encontraron pre cotizaciones sin ligar"
                )
              }
              onSearch={this.buscarPreCotizaciones}
              onChange={(value) => this.seleccionar(value)}
              value={this.state.preCotizacionIdSeleccionada}
              dropdownRender={(menu) => <Spin spinning={this.state.cargando}>{menu}</Spin>}
            >
              {this.state.opciones.map((preCotizacion) => (
                <Option key={preCotizacion._id} value={preCotizacion._id}>
                  {`${preCotizacion.serie || ""}-${preCotizacion.numero || ""} - ${preCotizacion.nombreProyecto || ""}`}
                </Option>
              ))}
            </Select>

            {preCotizacionSeleccionada && (
              <div
                style={{
                  marginTop: 16,
                  padding: "16px 18px",
                  borderRadius: 10,
                  border: "1px solid #eee",
                  background: "linear-gradient(180deg, #fafcff 0%, #f5f7fa 100%)",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                    paddingBottom: 10,
                    borderBottom: "1px solid #e8eef2",
                  }}
                >
                  <span style={{ fontSize: 16, fontWeight: 700, color: "#00BFD6" }}>
                    {preCotizacionSeleccionada.serie}-{preCotizacionSeleccionada.numero}
                  </span>
                  <div style={{ display: "flex", gap: 6 }}>
                    {preCotizacionSeleccionada.urgente && <Tag color="red">Urgente</Tag>}
                    <Tag color={preCotizacionSeleccionada.estado === 1 ? "green" : "orange"}>
                      {preCotizacionSeleccionada.estado === 1 ? "Activo" : "Deshabilitado"}
                    </Tag>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: 8, columnGap: 14, fontSize: 13 }}>
                  <div style={{ gridColumn: "1 / -1" }}>
                    <span style={{ color: "#999" }}>Proyecto:</span>{" "}
                    <strong>{preCotizacionSeleccionada.nombreProyecto || "—"}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#999" }}>Cliente:</span>{" "}
                    <strong>{preCotizacionSeleccionada.cliente || "—"}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#999" }}>Contacto:</span>{" "}
                    <strong>{preCotizacionSeleccionada.contacto || "—"}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#999" }}>Encargado:</span>{" "}
                    <strong>{preCotizacionSeleccionada.encargadoProyecto || "—"}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#999" }}>Fecha Compromiso:</span>{" "}
                    <strong>
                      {preCotizacionSeleccionada.fechaCompromiso
                        ? moment(preCotizacionSeleccionada.fechaCompromiso).format("DD/MM/YYYY")
                        : "—"}
                    </strong>
                  </div>
                  <div style={{ gridColumn: "1 / -1" }}>
                    <span style={{ color: "#999" }}>Creada:</span>{" "}
                    <strong>
                      {preCotizacionSeleccionada.createdAt
                        ? moment(preCotizacionSeleccionada.createdAt).format("DD/MM/YYYY")
                        : "—"}
                    </strong>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ElegirPreCotizacion);
